import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadDetail($input: LoadDetailEdit) {
        updateLoadDetail(input: $input) {
            errors
        }
    }
`;
